import { render, staticRenderFns } from "./categoryPodcast.vue?vue&type=template&id=50d689d8&scoped=true&"
import script from "./categoryPodcast.vue?vue&type=script&lang=js&"
export * from "./categoryPodcast.vue?vue&type=script&lang=js&"
import style0 from "./categoryPodcast.vue?vue&type=style&index=0&id=50d689d8&scoped=true&lang=css&"
import style1 from "./categoryPodcast.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d689d8",
  null
  
)

export default component.exports